import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page not-found-page">
      <h1>Page not found</h1>
      <p>The page you requested is not in this archive.</p>
      <Link to="/" className="btn btn-primary">
        Return home
      </Link>
    </div>
  );
}
